export interface Location {
  formattedAddress: string;
  geo: {
    type: string;
    coordinates: number[];
  };
}

export interface Picture {
  url: string;
  type: string;
  size: string;
  thumb: string;
}

export interface Category {
  id: string;
  name: string;
}

export interface ActivityGroup {
  id: string;
  name: string;
  categories:string[]
}

export interface Product {
  id: string;
  name: string;
}

export interface Service {
  id: string;
  name: string;
  icon: string;
}

export interface Sponsor {
  name: string;
  logo: Picture;
}

export interface Promotion {
  id: string;
  name: string;
  type: string;
  qty: number;
  sponsor?: Sponsor;
  picture?: Picture;
  enabled: boolean;
  descriptionClient?: string;
}

export interface BookedPromotion {
  id: string;
  status: string;
  promotion: Promotion;
  catalog: Catalog;
  loyaltyCardRelation: boolean;
  timeRange: TimeRange;
}

export interface Menu {
  name: string;
  description: string;
  mainPicture: Picture;
  price: number;
  pictures: Picture[];
  availability: Repeat;
  mealType: MealType;
}

export interface Drink {
  name: string;
  icon: string;
}

export interface DrinkMenu {
  name: string;
  drink: Drink;
}

export interface TimeRange {
  from: string;
  to: string;
}

export interface PromotionCatalog {
  active: boolean;
  promotion: Promotion;
  timeRange: TimeRange;
  limit: number;
  repeat: Repeat;
  loyaltyCardRelation: boolean;
  disabled?: boolean;
  name: string;
  price: number;
  product:Product[];
}

export interface CatalogTime {
  repeat: boolean[];
  time: {
    from: string;
    to: string;
  };
}

export interface Repeat {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export interface MealType {
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
}

export interface Catalog {
  id: string;
  name: string;
  richdescription: string;
  description: string;
  mainPicture: Picture;
  pictures: Picture[];
  activitygroup: ActivityGroup[];
  categories: Category[];
  promotions: PromotionCatalog[];
  services: Service[];
  acceptsCredits: boolean;
  isHighlighted: boolean;
  location: Location;
  mainMenus: Menu[];
  mainSnacks: Menu[];
  mainDrinks: DrinkMenu[];
  mainSpecialities: Speciality[];
  paymentMethod: number;
  status: string;
  openingTime: CatalogTime;
  phoneNumber: string;
  imported: boolean;
  product: Product[];
  canSendMessages: boolean;
  facebook: string;
  instagram: string;
  linkedin: string;
  twitter: string;
  youTube: string;
  pinterest: string;
  whatsapp: string;
}

export interface CatalogFilters {
  query: string;
  promotions: Promotion[];
  categories: Category[];
  services: Service[];
  acceptsCredits: boolean;
  paymentMethod: number;
  distance: number;
  priceRange: {
    lower: number;
    upper: number;
  };
  zipCode: string;
  city: string;
  province: string;
  activitygroup:ActivityGroup[];
  coords?: { latitude: string; longitude: string };
}

export interface SelectOption {
  label: string;
  value: string;
}

export interface Permission {
  feature: string;
  accessType: string;
}

export interface User {
  userId: string;
  permissions: Permission[];
  role: string;
  status: string;
  lastLogin: string;
  username: string;
  name: string;
  lastName: string;
  language: string;
  picture: Picture;
  notification: boolean;
  interests: Category[];
}

export interface Newsletter {
  size: number;
  picture: Picture;
  title: string;
  subtitle: string;
  detail: string;
  updatedAt: string;
  createdAt: string;
  id: string;
}

export interface Reward {
  points: number;
  reward: number;
  amount: number;
  name: string;
  picture: Picture;
  updatedAt: string;
  createdAt: string;
  id: string;
}

export interface AlertButtons {
  text: string;
  handler: any;
  role: string;
}

export interface LoyaltyCard {
  redeemed: any[];
  catalog: Catalog;
  user: string;
  createdAt: string;
  expire: string;
  promotion: Promotion;
  updatedAt: string;
  id: string;
}

export interface Speciality {
  name: string;
}

export interface Policy {
  code: string;
  content: string;
  title: string;
}

export interface FeatureFlags {
  showMainMenus?: boolean;
  showMainSnacks?: boolean;
  showMainDrinks?: boolean;
  showMainSpecialities?: boolean;
  filterPrice?: boolean;
  loginFacebook?: boolean;
  loginGoogle?: boolean;
  loginApple?: boolean;
}
